import { Dialog, IconButton, Skeleton } from '@mui/material'
import React,{useEffect, useMemo, useState} from 'react'
import { useSelector } from 'react-redux'
import '../../../../../../css/Staff/HRM/Tab/empPayslip.css'
import { fetchAllPayslipAPI } from '../../../../Payroll/parollAPIs'

export const EmpPayslip = () => {
  const currentEmpID = localStorage.getItem('EMP_ID');
  const [paySlipView,setPaySlipView]=useState(false)
  const [isLoading,setIsLoading]=useState(false)
  const [payslips,setPayslips]=useState([])
  const [selectedPayslip,setSelectedPayslip]=useState(null)

  const loginResponse = useSelector((state)=>state.loginResponseSlice.value)

  useEffect(()=>{
    const load = async ()=>{
      try{
        setIsLoading(true)
        await fetchAllPayslipAPI({
          body: { page: 1, limit: 50, empId: currentEmpID },
          successCallback: (res)=>{
            const list = res?.data?.list || res?.list || []
            // If API doesn't support empId filter, filter client-side
            const filtered = list.filter(ps => String(ps?.empId?._id || ps?.employeeDetails?._id || ps?.empId) === String(currentEmpID))
            setPayslips(filtered.length ? filtered : list)
          },
          errorCallback: ()=>{}
        })
      } finally {
        setIsLoading(false)
      }
    }
    if(currentEmpID){ load() }
  },[currentEmpID])

  const handleView = (ps)=>{
    setSelectedPayslip(ps)
    setPaySlipView(true)
  }

  return (
    <div className='dashboard-employee-leave-details-container'>
      <div className='dashboard-employee-leave-details-top-container'>
        <div className='dashboard-employee-leave-details-top-btn-grp-container'>
          <h4>PaySlip Summary</h4>
        </div>
      </div>
      <div className='global-table-container dashboard-leave-details-table-container'>
        <table className='global-table'>
          <thead>
            <tr>
              <th>No</th>
              <th>Payslip No.</th>
              <th>Period</th>
              <th>Net Salary</th>
              <th>Status</th>
              <th>View</th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              <tr>
                <td colSpan={6}>
                  <Skeleton variant="rectangular" animation="wave" width={'100%'} height={40} />
                </td>
              </tr>
            </tbody>
          ):(
            <tbody>
              {Array.isArray(payslips) && payslips.length>0 ? payslips.map((r,i)=> (
                <tr key={r?._id || i}>
                  <td>{i+1}</td>
                  <td>{r?.name || r?.paySlipNo}</td>
                  <td>{(r?.fromDate && r?.toDate) ? `${new Date(r.fromDate).toLocaleDateString()} - ${new Date(r.toDate).toLocaleDateString()}` : ''}</td>
                  <td>{r?.netSalary ?? r?.netAmount ?? 0}</td>
                  <td>{(r?.status || '').toString()}</td>
                  <td>
                    <IconButton onClick={()=>handleView(r)}>
                      <i className="bi bi-eye visibility-icon"></i>
                    </IconButton>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan={6}>No Records</td>
                </tr>
              )}
            </tbody>
          )}
        </table>
      </div>

      <Dialog open={paySlipView} maxWidth="lg" onClose={()=>setPaySlipView(false)} onKeyDown={(e)=>e.key === 'Escape' && setPaySlipView(false)}>
        <div className='dashboard-employee-payslip-view-container'>
          <div className='dashboard-employee-payslip-view-top-container'>
            <h3>Payslip</h3>
            <div className='dashboard-employee-payslip-view-top-icon-container'>
              <IconButton className='payslip-print-icon'>
                <i className='bi bi-printer printer-icon'></i>
              </IconButton>
              <IconButton className='payslip-download-icon'>
                <i className='bi bi-arrow-down-circle download-icon'></i>
              </IconButton>
            </div>
          </div>
          <hr className='global-hr'/>
          <div className='dashboard-employee-payslip-view-bottom-container'>
            <div className='dashboard-employee-payslip-view-bottom-first-container'>
              <p>Employee Name&nbsp;:&nbsp;{selectedPayslip?.employeeDetails?.staff_name || selectedPayslip?.employeeData?.empName || ''}</p>
              <p>Employee ID &nbsp;:&nbsp;{selectedPayslip?.employeeDetails?.emp_id || ''}</p>
            </div>
            <div className='payslip-view-table'>
              <div className='earnings'>
                <h3>Earnings</h3>
                <div className='earnings-sub-heading'>
                  <p className='pay-type'>PayType</p>
                  <p className='amount'>Amount</p>
                </div>
                {(selectedPayslip?.earnings || []).map((e,i)=> (
                  <div className='earnings-content' key={i}>
                    <p className='pay-type'>{e?.earningsType || e?.name}</p>
                    <p className='amount'>{e?.amount}</p>
                  </div>
                ))}
                <div className='total-earnings-salary'>
                  <p className='pay-type'>Total Earnings</p>
                  <p className='amount'>{selectedPayslip?.grossSalary ?? 0}</p>
                </div>
              </div>
              <div className='earnings'>
                <h3>Deduction</h3>
                <div className='earnings-sub-heading'>
                  <p className='pay-type'>PayType</p>
                  <p className='amount'>Amount</p>
                </div>
                {(selectedPayslip?.deductions || []).map((d,i)=> (
                  <div className='earnings-content' key={i}>
                    <p className='pay-type'>{d?.deductionType || d?.name}</p>
                    <p className='amount'>{d?.amount}</p>
                  </div>
                ))}
                <div className='total-earnings-salary'>
                  <p className='pay-type'>Total Deductions</p>
                  <p className='amount'>{selectedPayslip?.totalDeductions ?? 0}</p>
                </div>
              </div>
            </div>
            <div className='payslip-net-salary-container'>
              <div className='payslip-net-salary-left-container'>
                <h4>Net Salary</h4>
                <p>In Words</p>
              </div>
              <div className='payslip-net-salary-left-container'>
                <h4>{selectedPayslip?.netSalary ?? 0}</h4>
                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  )
}
